import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListGroupsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List groups</div>
          <div className="text">Returns a paginated list of groups for your company.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                heading: 'apiKey',
                subheading: 'string',
                description: 'Your secret API key.',
              },
              {
                heading: 'cursor',
                subheading: 'string (optional)',
                description:
                  'A pagination cursor returned from a previous request. Use it to fetch the next page of results.',
              },
              {
                heading: 'limit',
                subheading: 'number (optional)',
                description:
                  'The number of groups to fetch. Defaults to 50 if not specified. Maximum is 100.',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with an "items" array of group objects, a "hasNextPage" boolean indicating
            if more results are available, and a "cursor" string to fetch the next page when
            hasNextPage is true.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/groups/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/groups/list"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d limit=10`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "cursor": "eyJhZnRlciI6eyJfaWQiOiI1NTNjM2VmOGI4Y2RjZD...",
  "hasNextPage": true,
  "items": [{
    "id": "553c3ef8b8cdcd1501ba1235",
    "name": "Product",
    "description": "Ideas related to the product surface area.",
    "urlName": "product"
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
